import { render } from "./BroadcasterInfo.vue?vue&type=template&id=7e4dfe80"
import script from "./BroadcasterInfo.vue?vue&type=script&lang=ts"
export * from "./BroadcasterInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script